'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Note = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Note, _Component);

  function Note() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Note);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Note.__proto__ || (0, _getPrototypeOf2.default)(Note)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: _this.props.value || '',
      max: _this.props.max || 90
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Note, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.value) {
        this.setState({ value: nextProps.value });
      }
    }
  }, {
    key: 'handleChangeInput',
    value: function handleChangeInput(event) {
      var value = event.target.value;
      this.setState({ value: value });
      this.props.onChange(value);
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      var text = e.target.value;
      var value = this.props.value;

      if (typeof value === 'string') {
        this.props.onChange(text);
      } else {
        this.setState({ value: text });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Note.scss');
      var valueProps = this.props.value;
      var max = this.state.max;

      var value = typeof valueProps === 'string' ? valueProps : this.state.value;
      return _react2.default.createElement(
        'div',
        { className: styles.note },
        _react2.default.createElement('textarea', {
          className: styles.textarea,
          type: 'text',
          placeholder: 'V\xED d\u1EE5: Da nh\u1EA1y c\u1EA3m, xin shop nh\u1EB9 tay',
          value: value,
          rows: '2',
          onChange: this.onChange.bind(this)
        }),
        _react2.default.createElement(
          'small',
          { className: 'form-text text-muted' },
          '* T\u1ED1i \u0111a ',
          max - value.length,
          ' k\xFD t\u1EF1'
        )
      );
    }
  }]);
  return Note;
}(_react.Component), _class.propTypes = {
  value: _react.PropTypes.string,
  max: _react.PropTypes.number,
  onChange: _react.PropTypes.func
}, _temp2);
exports.default = Note;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/Note.js
// module id = 1562
// module chunks = 0